
import React from 'react';
import OrderProductItem from './OrderProductItem';
import ProductsTableHeader from './ProductsTableHeader';
import { 
  Table,
  TableBody,
} from "@/components/ui/table";

interface Product {
  id: string;
  name: string;
  price: number;
  quantity: number;
  total?: number;
  product_id?: string;
  currency?: string;
}

interface ProductsTableProps {
  products: Product[];
  onRemoveProduct: (productId: string) => void;
}

const ProductsTable = ({ products, onRemoveProduct }: ProductsTableProps) => {
  console.log("Rendering products table with products:", products);
  
  return (
    <div className="reference-table-container overflow-x-auto">
      <Table>
        <ProductsTableHeader />
        <TableBody>
          {products.map((product) => (
            <OrderProductItem 
              key={product.id}
              product={product}
              onRemove={onRemoveProduct}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ProductsTable;
